import React from 'react';

export default ({ size = 16, color = '#000' }) => (
  <svg
    height={size}
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path
      style={{ transformOrigin: '50% 50%', transform: 'scale(2)' }}
      fill={color}
      d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/Chevron.js